import { createSlice, PayloadAction, createAsyncThunk, Dispatch, AnyAction, UnknownAction } from '@reduxjs/toolkit';
import { AdminPagesTypes, IAdminPage } from './Interfaces';
import { RootState, store } from "../../app/store"
import DashboardBasePage from '../dashboard/DashboardBasePage';
import { useSelector } from 'react-redux';
import { useMatch } from 'react-router-dom';
import WarehousesBasePage from '../warehouses/WarehousesBasePage';
import LocationsBasePage from '../locations/LocationsBasePage';
import NewWarehousesPage from '../warehouses/NewWarehousePage';
import NewLocationPage from '../locations/NewLocationPage';
import AdminDynamicPage from './AdminDynamicPage';
import LocationsApp from '../locations/LocationsApp';
import AdminDynamicBasePage from './AdminDynamicBasePage';
import WarehousesApp from '../warehouses/WarehousesApp';
import AdminDynamicCreateOrUpdatePage from './AdminDynamicCreateOrUpdatePage';
import SectionsBasePage from '../sections/SectionsBasePage';
import SectionsApp from '../sections/SectionsApp';
import NewSectionPage from '../sections/NewSectionPage';
import CategoriesBasePage from '../categories/CategoriesBasePage';
import NewCategoryPage from '../categories/NewCategoryPage';
import CategoriesApp from '../categories/CategoriesApp';
import ItemsBasePage from '../items/ItemsBasePage';
import NewItemPage from '../items/NewItemPage';
import ItemsApp from '../items/ItemsApp';
import ViewSingleItemPage from '../items/ViewSingleItemPage';
import DynamicItemViewPage from './DynamicItemViewPage';
import ViewSingleWarehousePage from '../warehouses/ViewSingleWarehousePage';
import TransactionsList from '../transactions/TransactionsList';
import IssuesList from '../issues/IssuesList';
import IssuesApp from '../issues/IssuesApp';
import ResolveIssue from '../issues/ResolveIssue';
import ViewSingleIssuePage from '../issues/ViewSingleIssuePage';
import UsersApp from '../user/UsersApp';
import AdminDynamicBasePage2 from './AdminDynamicBasePage2';
import ViewSingleUserPage from '../user/ViewSingleUserPage';
import TransactionsApp from '../transactions/TransactionsApp';
import BrandsApp from '../brands/BrandsApp';
import QrCodesPage from '../items/QrCodesPage';
import ProjectsApp from '../projects/ProjectsApp';
import AdminGridDataBasePage from './AdminGridDataBasePage';
import ViewSingleItemPageByUniqueId from '../items/ViewSingleItemPageByUniqueId';
import ItemsRequestsApp from '../items_requests/ItemsRequestsApp';
import ViewRequest from '../items_requests/ViewRequest';
import NewRequest from '../items_requests/NewRequest';
import NewItemsRequestPage from '../items_requests/NewItemsRequestPage';
import UpdatesApp from '../updates/UpdatesApp';
import UserGroupsApp from '../user_groups/UserGroupsApp';
import CreateOrUpdateUserGroup from '../user_groups/CreateOrUpdateUserGroup';
import BaseApp from '../BaseApp';
import { IBasicModalWindowButton } from '../../components/BasicModalWIndow';
import PrintersApp from '../printing/PrintersApp';
import ViewSinglePrinterPage from '../printing/ViewSinglePrinterPage';
import WarehousesListPage from '../warehouses/WarehousesListPage';

interface IQuickElementPreview {
    open: boolean,
    appClass: () => BaseApp,
    title: string,
    actionButtons?: IBasicModalWindowButton[],
    elementId: number,
    customContent?: (elemId: number) => JSX.Element,
    enableCustomContent?: boolean,
    showTitle?: boolean
}

interface IAdminPagesState {
    pages: Array<IAdminPage>,
    smallerSideBar?: boolean,
    showMobileSidebar?: boolean,
    quickPreview: IQuickElementPreview,
}

const initialState: IAdminPagesState = {
    pages: [
        {
            name: "dashboard",
            title: "Dashboard",
            icon: "home",
            subPages: [],
            showInMenu: true,
            pageComponents: {
                viewPage: DashboardBasePage
            },
            messages: {
                create: "",
                createShort: "",
                edit: "",
                editShort: "",
                delete: "",
                deleteShort: "",
                view: "",
                nothingFound: ""
            }
        },
        {
            name: "warehouses",
            title: "Warehouses",
            icon: "inventory",
            subPages: [
                {
                    name: "sections",
                    title: "Sections",
                    icon: "map",
                    subPages: [],
                    showInMenu: true,
                    pageComponents: {
                        // viewPage: SectionsBasePage,
                        viewPage: AdminGridDataBasePage,
                        newPage: NewSectionPage,
                        editPage: NewSectionPage,
                        itemViewPage: DynamicItemViewPage
                    },
                    subPageName: "warehouses",
                    messages: {
                        create: "Create a new section",
                        createShort: "New section",
                        edit: "Edit section",
                        editShort: "Edit",
                        delete: "Delete section",
                        deleteShort: "Delete",
                        view: "View section",
                        nothingFound: "No sections have been found.",
                    },
                    appClass: new SectionsApp()
                },
            ],
            showInMenu: true,
            pageComponents: {
                // viewPage: WarehousesBasePage,
                // viewPage: AdminGridDataBasePage,
                viewPage: WarehousesListPage,
                newPage: NewWarehousesPage,
                editPage: NewWarehousesPage,
                itemViewPage: ViewSingleWarehousePage
            },
            messages: {
                create: "Create a new warehouse",
                createShort: "New warehouse",
                edit: "Edit warehouse",
                editShort: "Edit",
                delete: "Delete warehouse",
                deleteShort: "Delete",
                view: "View warehouse",
                nothingFound: "No warehouses have been found.",
            },
            appClass: new WarehousesApp()
        },
        {
            name: "locations",
            title: "Locations",
            icon: "map",
            subPages: [],
            showInMenu: true,
            pageComponents: {
                // viewPage: LocationsBasePage,
                viewPage: AdminGridDataBasePage,
                newPage: AdminDynamicPage,
                editPage: AdminDynamicPage,
                itemViewPage: DynamicItemViewPage
            },
            subPageName: "",
            messages: {
                create: "Create a new location",
                createShort: "New location",
                edit: "Edit location",
                editShort: "Edit",
                delete: "Delete location",
                deleteShort: "Delete",
                view: "View location",
                nothingFound: "No locations have been found.",
            },
            appClass: new LocationsApp()
        },
        {
            name: "projects",
            title: "Projects",
            icon: "document",
            subPages: [],
            showInMenu: true,
            pageComponents: {
                // viewPage: AdminDynamicBasePage2,
                viewPage: AdminGridDataBasePage,
                newPage: AdminDynamicPage,
                editPage: AdminDynamicPage,
                itemViewPage: DynamicItemViewPage
            },
            subPageName: "",
            messages: {
                create: "Create a new project",
                createShort: "New project",
                edit: "Edit project",
                editShort: "Edit",
                delete: "Delete project",
                deleteShort: "Delete",
                view: "View project",
                nothingFound: "No projects have been found.",
            },
            appClass: new ProjectsApp()
        },
        {
            name: "brands",
            title: "Brands",
            icon: "brands",
            subPages: [],
            showInMenu: true,
            pageComponents: {
                // viewPage: AdminDynamicBasePage2,
                viewPage: AdminGridDataBasePage,
                newPage: AdminDynamicPage,
                editPage: AdminDynamicPage,
                itemViewPage: DynamicItemViewPage
            },
            subPageName: "",
            messages: {
                create: "Create a new brand",
                createShort: "New brand",
                edit: "Edit brand",
                editShort: "Edit",
                delete: "Delete brand",
                deleteShort: "Delete",
                view: "View brand",
                nothingFound: "No brands have been found.",
            },
            appClass: new BrandsApp()
        },
        {
            name: "item_requests",
            title: "Requests",
            icon: "request",
            subPages: [],
            showInMenu: true,
            pageComponents: {
                viewPage: AdminGridDataBasePage,
                itemViewPage: ViewRequest,
                newPage: NewItemsRequestPage,
            },
            subPageName: "",
            messages: {
                create: "Create a new request",
                createShort: "New request",
                edit: "Edit request",
                editShort: "Edit",
                delete: "Delete request",
                deleteShort: "Delete",
                view: "View request",
                nothingFound: "No requests have been found.",
            },
            appClass: new ItemsRequestsApp(),
            isBeta: true,
        },
        {
            name: "items",
            title: "Items",
            icon: "list",
            subPages: [
                {
                    name: "categories",
                    title: "Categories",
                    icon: "folder",
                    subPages: [],
                    showInMenu: true,
                    pageComponents: {
                        viewPage: CategoriesBasePage,
                        // viewPage: AdminGridDataBasePage,
                        newPage: NewCategoryPage,
                        editPage: NewCategoryPage
                    },
                    subPageName: "items",
                    messages: {
                        create: "Create a new category",
                        createShort: "New category",
                        edit: "Edit category",
                        editShort: "Edit",
                        delete: "Delete category",
                        deleteShort: "Delete",
                        view: "View category",
                        nothingFound: "No categories have been found.",
                    },
                    appClass: new CategoriesApp()
                },
                {
                    name: "transactions",
                    title: "Transactions",
                    icon: "list",
                    subPages: [],
                    showInMenu: true,
                    pageComponents: {
                        viewPage: TransactionsList,
                        itemViewPage: DynamicItemViewPage
                    },
                    subPageName: "items",
                    messages: {
                        create: "Create a new transaction",
                        createShort: "New transaction",
                        edit: "Edit transaction",
                        editShort: "Edit",
                        delete: "Delete transaction",
                        deleteShort: "Delete",
                        view: "View transaction",
                        nothingFound: "No transcations have been found.",
                    },
                    appClass: new TransactionsApp()
                },
                {
                    name: "issues",
                    title: "Issuses",
                    icon: "list",
                    subPages: [],
                    showInMenu: true,
                    pageComponents: {
                        viewPage: IssuesList,
                        newPage: AdminDynamicPage,
                        editPage: ResolveIssue,
                        itemViewPage: ViewSingleIssuePage
                    },
                    subPageName: "items",
                    messages: {
                        create: "Create a new issue",
                        createShort: "New issue",
                        edit: "Edit issue",
                        editShort: "Edit",
                        delete: "Delete issue",
                        deleteShort: "Delete",
                        view: "View issue",
                        nothingFound: "No issues have been found.",
                    },
                    appClass: new IssuesApp()
                },
                {
                    name: "qrcodes",
                    title: "QR Codes",
                    icon: "qrcode",
                    subPages: [],
                    showInMenu: true,
                    pageComponents: {
                        viewPage: QrCodesPage,
                    },
                    subPageName: "items",
                    messages: {
                        create: "Create a new qrcode",
                        createShort: "New qrocde",
                        edit: "Edit issue",
                        editShort: "Edit",
                        delete: "Delete issue",
                        deleteShort: "Delete",
                        view: "View issue",
                        nothingFound: "No qrcodes have been found.",
                    },
                },
            ],
            showInMenu: true,
            pageComponents: {
                viewPage: ItemsBasePage,
                // viewPage: AdminDynamicBasePage2,
                newPage: NewItemPage,
                editPage: NewItemPage,
                itemViewPage: ViewSingleItemPageByUniqueId
            },
            subPageName: "",
            messages: {
                create: "Create a new item",
                createShort: "New item",
                edit: "Edit item",
                editShort: "Edit",
                delete: "Delete item",
                deleteShort: "Delete",
                view: "View item",
                nothingFound: "No items have been found.",
            },
            appClass: new ItemsApp()
        },
        {
            name: "users",
            title: "Users",
            icon: "users",
            subPages: [
                {
                    name: "user_groups",
                    title: "Departments",
                    icon: "users",
                    subPages: [],
                    showInMenu: true,
                    pageComponents: {
                        // viewPage: AdminDynamicBasePage2,
                        viewPage: AdminGridDataBasePage,
                        newPage: CreateOrUpdateUserGroup,
                        editPage: CreateOrUpdateUserGroup,
                        itemViewPage: ViewSingleUserPage
                    },
                    subPageName: "users",
                    messages: {
                        create: "Create a new user department",
                        createShort: "New department",
                        edit: "Edit department",
                        editShort: "Edit",
                        delete: "Delete department",
                        deleteShort: "Delete",
                        view: "View department",
                        nothingFound: "No departments have been found.",
                    },
                    appClass: new UserGroupsApp()
                },
            ],
            showInMenu: true,
            pageComponents: {
                // viewPage: AdminDynamicBasePage2,
                viewPage: AdminGridDataBasePage,
                newPage: AdminDynamicPage,
                editPage: AdminDynamicPage,
                itemViewPage: ViewSingleUserPage
            },
            subPageName: "",
            messages: {
                create: "Create a new user",
                createShort: "New user",
                edit: "Edit user",
                editShort: "Edit",
                delete: "Delete user",
                deleteShort: "Delete",
                view: "View user",
                nothingFound: "No users have been found.",
            },
            appClass: new UsersApp()
        },
        {
            name: "printers",
            title: "Printers",
            icon: "print",
            subPages: [],
            showInMenu: true,
            pageComponents: {
                // viewPage: AdminDynamicBasePage2,
                viewPage: AdminGridDataBasePage,
                newPage: AdminDynamicPage,
                editPage: AdminDynamicPage,
                itemViewPage: ViewSinglePrinterPage
            },
            subPageName: "",
            messages: {
                create: "Create a new printer",
                createShort: "New printer",
                edit: "Edit printer",
                editShort: "Edit",
                delete: "Delete printer",
                deleteShort: "Delete",
                view: "View printer",
                nothingFound: "No printers have been found.",
            },
            appClass: new PrintersApp(),
            isDaemonOnly: true,
        },
        {
            name: "updates",
            title: "Updates",
            icon: "document",
            subPages: [],
            showInMenu: true,
            pageComponents: {
                // viewPage: AdminDynamicBasePage2,
                viewPage: AdminGridDataBasePage,
                newPage: AdminDynamicPage,
                editPage: AdminDynamicPage,
                itemViewPage: DynamicItemViewPage
            },
            subPageName: "",
            messages: {
                create: "Create a new update",
                createShort: "New update",
                edit: "Edit update",
                editShort: "Edit",
                delete: "Delete update",
                deleteShort: "Delete",
                view: "View update",
                nothingFound: "No updates have been found.",
            },
            appClass: new UpdatesApp(),
            isDaemonOnly: true,
        },
    ],
    smallerSideBar: false,
    showMobileSidebar: false,
    quickPreview: {
        open: false,
        title: "No title",
        appClass: () => new BaseApp(),
        elementId: 0,
        showTitle: true
    }
}

const adminPagesSlice = createSlice({
    name: "adminPages",
    initialState,
    // reducers: {
    //     updateSmallerSideBarStatus: (state: IAdminPagesState, action: PayloadAction<boolean>) => {
    //         state.smallerSideBar = action.payload
    //         window.localStorage.setItem("small_sidebar", action.payload ? "enabled" : "disabled")
    //     },
    //     updateShowMobileSidebarStatus: (state: IAdminPagesState, action: PayloadAction<boolean>) => {
    //         state.showMobileSidebar = action.payload
    //     }
    // }
    reducers: {
        updateSmallerSideBarStatus: (state, action: PayloadAction<boolean>) => {
          state.smallerSideBar = action.payload;
          window.localStorage.setItem("small_sidebar", action.payload ? "enabled" : "disabled");
        },
        updateShowMobileSidebarStatus: (state, action: PayloadAction<boolean>) => {
          state.showMobileSidebar = action.payload;
        },
        updateQuickPreviewOpenStatus: (state, action: PayloadAction<boolean>) => {
          state.quickPreview.open = action.payload;
        },
        updateQuickPreviewAppClass: (state, action: PayloadAction<() => BaseApp>) => {
          state.quickPreview.appClass = action.payload;
        },
        updateQuickPreview: (state, action: PayloadAction<IQuickElementPreview>) => {
          state.quickPreview = action.payload;
        }
      }
})

/**
 * Return page details with hook
 */
export const usePageDetails = (name: string) => {
    const pages = useSelector((state: RootState) => state.adminPages.pages)

    let details: IAdminPage = {
        name: "",
        title: "None",
        icon: "home",
        subPages: [],
        showInMenu: false,
        pageComponents: {},
        messages: {
            create: "",
            createShort: "",
            edit: "",
            editShort: "",
            delete: "",
            deleteShort: "",
            view: "",
            nothingFound: "",
        }
    }

    if (pages && pages.length > 0){
        pages.map((page: IAdminPage) => {
            if (page.name === name){
                details = page
            }else{
                if (page.subPages.length > 0){
                    page.subPages.map((subPage) => {
                        if (subPage.name === name){
                            details = subPage
                        }
                    })
                }
            }
        })
    }

    return details
}

export const returnPageDetails = (name: string, pages: IAdminPage[]) => {

    let details: IAdminPage = {
        name: "",
        title: "None",
        icon: "home",
        subPages: [],
        showInMenu: false,
        pageComponents: {},
        messages: {
            create: "",
            createShort: "",
            edit: "",
            editShort: "",
            delete: "",
            deleteShort: "",
            view: "",
            nothingFound:"",
        }
    }

    if (pages && pages.length > 0){
        pages.map((page: IAdminPage) => {
            if (page.name === name){
                details = page
            }else{
                if (page.subPages.length > 0){
                    page.subPages.map((subPage) => {
                        if (subPage.name === name){
                            details = subPage
                        }
                    })
                }
            }
        })
    }

    return details
}

/**
 * Return admin pages list
 */
export const useReturnAdminPagesList = () => useSelector((state: RootState) => state.adminPages.pages)

/**
 * Page type
 */
export const useReturnCurrentPageType = () => {
    let page: AdminPagesTypes = "base"

    const isBasePage = useMatch("/panel/:section_name")
    const isEditPage = useMatch("/panel/:section_name/edit/:id")
    const isViewPage = useMatch("/panel/:section_name/view/:id")
    const isNewPage  = useMatch("/panel/:section_name/new")

    if (isEditPage !== null){
        page = "edit"
    }

    if (isViewPage !== null){
        page = "view"
    }

    if (isBasePage !== null){
        page = "base"
    }

    if (isNewPage !== null){
        page = "new"
    }

    return page
}

export const AdminPagesService = {
    usePageDetails
}

export const handleOpenElementQuickPreview = (elementId: number, title: string, appClass: () => BaseApp, dispatch: Dispatch<UnknownAction>, actionButtons?: IBasicModalWindowButton[], enableCustomContent?: boolean, customContent?: (elemId: number) => JSX.Element, showTitle?: boolean) => dispatch(updateQuickPreview({
    open: true,
    elementId,
    title,
    appClass,
    actionButtons,
    enableCustomContent,
    customContent,
    showTitle,
}))

export const handleCloseElementQuickPreview = (dispatch: Dispatch<UnknownAction>) => dispatch(updateQuickPreview({
    open: false,
    title: "No Title",
    appClass: () => new BaseApp,
    actionButtons: [],
    elementId: 0,
    enableCustomContent: false,
    customContent: undefined,
    showTitle: false,
}))

export const { updateSmallerSideBarStatus, updateShowMobileSidebarStatus, updateQuickPreviewOpenStatus, updateQuickPreviewAppClass, updateQuickPreview } = adminPagesSlice.actions
export default adminPagesSlice.reducer